<div id="logo" class="logo">
  <img [src]="brandLogoUrl" alt="Atout France" class="brand" />
</div>

<section class="teaser-section" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave($event)">
  <video
    id="video"
    poster="./assets/video-preview.jpg"
    autoplay
    playsinline
    muted
    [muted]="mute"
    loop
    *ngIf="isTablet || isDesktop">
    <source [src]="video_source_dash" type="application/x-mpegURL" />
    <source [src]="video_source_webm" type="video/webm" />
    <source [src]="video_source_mp4" type="video/mp4" />
  </video>

  <div class="bg-image" *ngIf="isMobile" style="background-image: url('./assets/video-preview.jpg')">&nbsp;</div>

  <div class="controlbar" *ngIf="isDesktop || isTablet">
    <button mat-fab color="primary" aria-label="Play / Pause" (click)="togglePlay()">
      <mat-icon>{{ playingIcon }}</mat-icon>
    </button>
    &nbsp;
    <button mat-fab color="accent" aria-label="Mute / Unmute" (click)="toggleMute()">
      <mat-icon>{{ muteIcon }}</mat-icon>
    </button>
  </div>

  <div class="overlay" [@slideInOut]="backdropState">
    <div class="video-gradient"></div>
    <div class="video-pattern"></div>
  </div>

  <div [@slideInOut]="animationState" class="teaser-center">
    <div class="teaser-card french-border-top wrap mat-elevation-z4">
      <div class="teaser-content text-center" [innerHTML]="teaserHtml"></div>

      <div *ngIf="showCountdown" class="countdown-wrapper">
        <div class="countdown-unit" *ngFor="let unit of countdownUnits">
          <div class="flip-card" [class.flip]="unit.flipping">
            <div class="flip-card-top">{{ unit.value | number:'2.0-0' }}</div>
            <div class="flip-card-divider"></div>
            <div class="flip-card-bottom">{{ unit.value | number:'2.0-0' }}</div>
          </div>
          <span class="countdown-label">{{ unit.label }}</span>
        </div>
      </div>
    </div>
  </div>
</section>
